import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
export default /*#__PURE__*/ _defineComponent({
    __name: 'Loader',
    props: {
        loading: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_ctx.loading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Loading… "))
                : _createCommentVNode("", true);
        };
    }
});
